import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: JSON.parse(localStorage.getItem('notifications')) || []
};

const NotificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.notifications = action.payload;
      localStorage.setItem('notifications', JSON.stringify(state.notifications));
    },
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload);
      localStorage.setItem('notifications', JSON.stringify(state.notifications));
    },
    markAsRead: (state, action) => {
      const idx = state.notifications.findIndex(n => n.id === action.payload);
      if (idx !== -1) {
        state.notifications[idx].isRead = true;
        state.notifications[idx].isMarkRead = true;
        localStorage.setItem('notifications', JSON.stringify(state.notifications));
      }
    },
    markAllAsRead: (state) => {
      state.notifications.forEach(n => { n.isRead = true; n.isMarkRead = true; });
      localStorage.setItem('notifications', JSON.stringify(state.notifications));
    },
    deleteNotification: (state, action) => {
      state.notifications = state.notifications.filter(n => n.id !== action.payload);
      localStorage.setItem('notifications', JSON.stringify(state.notifications));
    }
  }
});

export const {
  setNotifications,
  addNotification,
  markAsRead,
  markAllAsRead,
  deleteNotification
} = NotificationSlice.actions;

export default NotificationSlice.reducer;
